import { render } from "./forgotPass.vue?vue&type=template&id=832b4a04"
import script from "./forgotPass.vue?vue&type=script&lang=js"
export * from "./forgotPass.vue?vue&type=script&lang=js"

import "./forgotPass.vue?vue&type=style&index=0&id=832b4a04&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__